import { createTheme } from '@mui/material';

const theme = createTheme({
    palette: {
        primary:{
            main:'#17082d'
        },
        secondary:{
            main:'#1976d2'
        }
    },
  });

  export  default theme;